import * as Sentry from "@sentry/react"
import { useEffect } from "react"
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router"

// "dev" is the deployed sandbox environment (sandbox.app.turnus.ai); local
// builds leave VITE_ENVIRONMENT unset, so Sentry stays off there.
const environment = import.meta.env.VITE_ENVIRONMENT

if (environment === "prod" || environment === "dev") {
  // see https://docs.sentry.io/platforms/javascript/guides/react/
  Sentry.init({
    environment,
    dsn: "https://6db9cf6279b2c4bcc581bfea7499cabf@o4509343174950912.ingest.de.sentry.io/4509343217549392",
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      "https://api.app.turnus.ai",
      "https://api.sandbox.app.turnus.ai",
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      // Router-aware tracing: names transactions by route pattern
      // (/questionnaire/:questionnaireId/answers) instead of the raw URL.
      // Also required for wrapReactRouterRouting in App.tsx to wrap <Routes>
      // at all.
      Sentry.reactRouterBrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
  })
}
